<h1 mat-dialog-title>Delete Category</h1>
<div mat-dialog-content>{{ message }}</div>
<div mat-dialog-actions class="float-right">
  <button class="btn btn-sm btn-secondary mr-2" (click)="cancel()">Cancel</button>
  <button type="submit" class="btn btn-sm btn-danger" (click)="delete()">Delete</button>
</div>
